import { useState, useEffect } from "react";
import { Spin, ConfigProvider, Empty, Modal, Button, Space, Tag } from "antd";
import { ArrowRightOutlined, ReloadOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import routes from "./routes";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { useSelector } from "react-redux";
import zhTW from "./locale";
import "./App.less";

library.add(fas);
library.add(fab);

const APP_CURRENT_VERSION = process.env.REACT_APP_VERSION;

const urlParams = new URLSearchParams(window.location.search);
const latestVersionFromUrl = urlParams.get("latest_version");
if (latestVersionFromUrl) {
  localStorage.setItem("app_latest_version", latestVersionFromUrl);
  urlParams.delete("latest_version");
  const newSearch = urlParams.toString();
  window.history.replaceState(
    {},
    "",
    window.location.pathname + (newSearch ? `?${newSearch}` : "")
  );
}

const customizeRenderEmpty = () => {
  return <Empty image={Empty.PRESENTED_IMAGE_DEFAULT} description={"尚無資訊"} />;
};

function App() {
  const spinning = useSelector(state => state.mask.spinning);
  const [upgradeLatestVersion, setUpgradeLatestVersion] = useState(null);

  useEffect(() => {
    const handler = e => setUpgradeLatestVersion(e.detail.latestVersion);
    window.addEventListener("app:upgrade-required", handler);
    return () => window.removeEventListener("app:upgrade-required", handler);
  }, []);

  const handleReload = () => {
    const currentPath = window.location.pathname + window.location.search + window.location.hash;
    window.location.href = upgradeLatestVersion
      ? `${window.location.origin}${currentPath}${currentPath.includes("?") ? "&" : "?"}latest_version=${upgradeLatestVersion}`
      : window.location.href;
  };

  return (
    <ConfigProvider renderEmpty={customizeRenderEmpty} locale={zhTW} componentSize="large">
      <Spin size="large" tip="讀取中，請稍後 ..." spinning={spinning} wrapperClassName={"appSpin"}>
        <main>{routes}</main>
      </Spin>
      <Modal
        open={!!upgradeLatestVersion}
        title={
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <ExclamationCircleOutlined style={{ color: "#faad14", fontSize: 22 }} />
            已偵測到新版本
          </span>
        }
        closable={false}
        maskClosable={false}
        keyboard={false}
        footer={
          <Button type="primary" block icon={<ReloadOutlined />} onClick={handleReload}>
            重新整理
          </Button>
        }
        width={520}
      >
        <p style={{ marginBottom: 16, color: "#000", lineHeight: 1.6 }}>
          系統偵測到您的版本過舊，請重新整理頁面以更新至最新版本。
        </p>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 12 }}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
            <span style={{ fontSize: 14, color: "#999" }}>目前版本</span>
            <Tag
              color="error"
              style={{ margin: 0, fontSize: 14, borderRadius: 20, padding: "5px 10px" }}
            >
              {APP_CURRENT_VERSION ? `v${APP_CURRENT_VERSION}` : "—"}
            </Tag>
          </div>
          <ArrowRightOutlined style={{ color: "#bbb", fontSize: 12, marginTop: 14 }} />
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
            <span style={{ fontSize: 14, color: "#999" }}>最新版本</span>
            <Tag
              color="success"
              style={{ margin: 0, fontSize: 14, borderRadius: 20, padding: "5px 10px" }}
            >
              {upgradeLatestVersion ? `v${upgradeLatestVersion}` : "—"}
            </Tag>
          </div>
        </div>
      </Modal>
    </ConfigProvider>
  );
}

export default App;
